export let itemListProps = {
    key: 0,
    id: 0,
    production_id: null,
    item_detail: null    
}

export let dataProps = {
    id: 0,
    from_store_id: null, 
    to_store_id: null,
    transfer_number: null,
    transfer_date: new Date(), 
    generated_by_staff_id: null, 
    status: 0,//draft, dispatched, accepted, canceled
    
    dispatch_date: new Date(),
    dispatch_by_staff_id: null,
    dispatch_notes: '',
    
    accept_date: new Date(), 
    accept_by_staff_id: null, 
    accept_notes: '', 
    
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/transferWorkOrder/properties.js